import { service } from "@/api/service ";
import { toast, toastError } from "@/components/custom/Toast";

const state = {
  roles: [],
  role: {},
  permissions: [],
  addStatus: false,
  editStatus: false,
  deleteStatus: false,
  checkedPermission: [],
};
const getters = {
  rolesListGet: (state) => state.roles,
  getRoleDetails: (state) => state.role,
  getPermissionsList: (state) => state.permissions,
  getCheckedPermissionList: (state) =>
    state.checkedPermission.map((item) => item.id),
};
const actions = {
  getRoles({ commit }) {
    service.getFun(`roles`).then(
      (obj) => {
        var result = obj?.data;
        commit("setRolesList", result);
      },
      (error) => {
        console.log("roles..." + error);
        toastError(error);
      }
    );
  },
  getPermissions({ commit }) {
    service.getFun("permissions").then(
      (obj) => {
        let result = obj?.data;
        commit("setPermissionsList", result);
      },
      (error) => {
        console.log("permissions..." + error);
        toastError(error);
      }
    );
  },
  getRoleById({ commit }, payload) {
    service.getFun(`roles/${payload}`).then(
      (obj) => {
        var result = obj?.data;
        commit("setRole", result);
      },
      (error) => {
        console.log("roles..." + error);
        toastError(error);
      }
    );
  },

  addRole({ commit }, payload) {
    console.log(payload, "this is payload");
    service
      .postFun(service.deleteNullValues(payload), `roles`, null, {
        action: "getRoles",
      })
      .then(
        (result) => {
          commit("addRoleStatus", result.success);
          toast(result.message);
        },
        (error) => {
          console.log("roles..." + error);
          toastError(error);
        }
      );
  },

  editRole({ commit }, payload) {
    service
      .postFun(service.deleteNullValues(payload), `roles/${payload.id}`, null, {
        action: "getRoles",
      })
      .then(
        (result) => {
          commit("editRoleStatus", result.success);
          toast(result.message);
        },
        (error) => {
          console.log("roles..." + error);
          toastError(error);
        }
      );
  },

  deleteRole({ commit }, payload) {
    console.log(payload, "payload");
    service
      .deleteFun(`roles/${payload?.payload}`, {
        action: "getRoles",
      })
      .then(
        (result) => {
          console.log(result, " results");
          commit("deleteRoleStatus", result?.success);
          toast(result?.message);
        },
        (error) => {
          toastError(error);
        }
      );
  },
};
const mutations = {
  setRolesList(state, roles) {
    state.roles = roles;
  },
  setPermissionsList(state, permissions) {
    state.permissions = permissions;
  },
  setRole(state, role) {
    state.role = role;
  },
  addRoleStatus(state, Status) {
    state.addStatus = Status;
  },
  editRoleStatus(state, Status) {
    state.editStatus = Status;
  },
  deleteRoleStatus(state, Status) {
    state.deleteStatus = Status;
  },
  checkedPermission(state, checkedPermission) {
    state.checkedPermission = checkedPermission;
  },
};
export default {
  state,
  getters,
  actions,
  mutations,
};
